module.exports = __webpack_public_path__ + "img/0.e9e0d598.png";